import {Component, Input, OnInit, EventEmitter, Output, forwardRef} from '@angular/core';
import {FormsModule, ReactiveFormsModule, FormControl, NG_VALUE_ACCESSOR, ControlValueAccessor} from '@angular/forms';
import {CountryISO, NgxIntlTelInputModule, PhoneNumberFormat, SearchCountryField} from 'ngx-intl-tel-input';
import {CommonModule} from '@angular/common';
import {PInvalidOnErrorDirective} from '../../directives/p-invalid-on-error.directive';
import {ErrorComponent} from '../../shared/error/error.component';

@Component({
  selector: 'app-phone-number',
  imports: [NgxIntlTelInputModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule, PInvalidOnErrorDirective, ErrorComponent],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PhoneNumberComponent),
      multi: true
    }
  ],
  standalone:true,
  templateUrl: './phone-number.component.html',
  styleUrl: './phone-number.component.scss',
})
export class PhoneNumberComponent implements OnInit, ControlValueAccessor {
  SearchCountryField = SearchCountryField;
  PhoneNumberFormat = PhoneNumberFormat;
  @Input() modal: boolean = false;
  @Input() required: boolean = false;
  @Input() formControl!: FormControl;
  @Input() preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  @Input() selectedCountryISO: any = CountryISO.India;
  @Output() countryChange = new EventEmitter<string>();
  disabled: boolean = false;

  onChange = (_: any) => {};

  onTouched = () => {};


  constructor(

  ) {

  }

  ngOnInit(): void {

  }

  handleCountryCode(countryCode: string): CountryISO {
    return countryCode ? countryCode.toLowerCase() as CountryISO : CountryISO.India;
  }

  writeValue(value: any): void {

  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

}
